import { gql } from "@apollo/client";

export const ClientListTotal = gql`
    query ClientListTotal {
        clientList {
            total
        }
    }
`;
